<!-- 根据魔方配置的跳转类型、跳转目标，生成不同的dom元素进行不同类型的跳转。目标：更好的SEO曝光效果 -->
<template>
  <a
    v-if="jumpUrl && jump_type && [1, 2, 3, 4].includes(jump_type)"
    :href="jumpUrl"
    :aria-label="ariaLabel"
    v-bind="$attrs"
    @click.prevent.stop="toJumpTarget"
    ><slot></slot
  ></a>
  <!-- 没有配跳转目标，也展示元素内容 -->
  <div v-else v-bind="$attrs" @click="toJumpTarget"><slot></slot></div>
</template>

<script setup lang="ts">
import type { ShowAppPop } from '@/api/types/default';
import type { MagicJumpItem } from '@/api/types/magic-jump';
import { PATH_LIST_FOR_ENTRANCE_PAGE_SCENE } from '@/assets/js/constants';
import { useStore } from '@/store';
import { computed, inject } from 'vue';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
defineOptions({
  inheritAttrs: false,
});

interface Props {
  item: MagicJumpItem;
  ariaLabel?: string;
  targetType?: string;
  entrancePageScene?: string;
}

const props = withDefaults(defineProps<Props>(), {
  ariaLabel: '',
  entrancePageScene: '其他',
});
const emit = defineEmits(['jumpComplete']);

const jump_type = computed<number | undefined>(() => props.item?.jump_type);
const Jump_target = computed<string>(() => String(props.item?.Jump_target ?? ''));
const showAppPop = inject<ShowAppPop | undefined>('showAppPop');

const jumpUrl = computed<string>(() => {
  // jump_type 跳转类型 number: 1 商品分组，2销售sku，3 系统页面，4 指定链接，5弹框
  if (!jump_type.value || !Jump_target.value) {
    return '';
  }
  let url = '';
  switch (jump_type.value) {
    case 1:
      url = `/goods-list/${Jump_target.value}`;
      break;
    case 2:
      url = `/goods-detail/${Jump_target.value}`;
      break;
    case 3:
      url = Jump_target.value;
      break;
    case 4:
      if (
        ['www.vooglam', 'm.vooglam', 'www-vooglam', 'm-vooglam'].some(
          (target) => Jump_target.value.includes(target),
           
        )
      ) {
        const href = new URL(Jump_target.value);
        url = href.href.replace(href.origin, '');
      } else {
        url = Jump_target.value;
      }
      break;
  }
  return url;
});

function toJumpTarget(): string | undefined {
  // jump_type 跳转类型 number: 1 商品分组，2销售sku，3 系统页面，4 指定链接，5弹框
  if (!jump_type.value || !Jump_target.value) {
    return '';
  }
  try {
    if (PATH_LIST_FOR_ENTRANCE_PAGE_SCENE.some((path) => jumpUrl.value.includes(path))) {
      sessionStorage.setItem('entrance_page_scene', props.entrancePageScene || '');
    }
  } catch (error) {
    console.log(error);
  }
  if ([1, 2, 3].includes(jump_type.value)) {
    router.push(jumpUrl.value);
  } else if (jump_type.value === 4) {
    // 注意：站内跳转已经在 jumpUrl 计算属性里做过兼容，这里不需要再次兼容
    if (jumpUrl.value.includes('http')) {
      if (jumpUrl.value.includes('club.co')) {
        if (!store.token) {
          showAppPop?.('register');
        } else {
          window.open(jumpUrl.value, '_blank');
        }
      } else {
        window.open(jumpUrl.value, '_blank');
      }
    } else {
      router.push(jumpUrl.value);
    }
  } else if (jump_type.value === 5) {
    // 打开弹窗
    if (Jump_target.value === '1' && !store.token) {
      showAppPop?.('register');
    } else {
      if (store.token) {
        store.SET_IS_RIGHT_NAV_CLICK(true);
      }
      showAppPop?.('coupon2');
    }
  }
  emit('jumpComplete');
}
</script>

<style lang="scss" scoped>
a {
  color: inherit;
}
</style>
